import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectedLanguage } from "../../store/slices/selectedLanguageSlice";
import translations from "../../language.json";

const Banner = () => {
  const selectedLanguages = useSelector(selectedLanguage);

  return (
    <section className="banner">
      <div className="banner__container container">
        <div className="banner__info">
          <h2>{translations[selectedLanguages].banner.title}</h2>
          <p>{translations[selectedLanguages].banner.description}</p>
        </div>
        <div className="banner__btns">
          <Link to="/about">
            {translations[selectedLanguages].banner.firstButton}
          </Link>
          <Link to="/contact">
            {translations[selectedLanguages].banner.secondButton}
          </Link>
        </div>
      </div>
    </section>
  );
};

export default Banner;
